import React from "react";
import { useTranslation } from "react-i18next";

function format(value) {
  if (value === null || value === undefined || value === "") return "-";
  const num = Number(value);
  if (!Number.isFinite(num)) return "-";
  return new Intl.NumberFormat("sv-SE").format(num);
}

const PriceMatricsComponent = ({ sellPrice, cost, margin })=>{
  const { t } = useTranslation();
  const hasSell = sellPrice !== null && sellPrice !== undefined && sellPrice !== "" && Number.isFinite(Number(sellPrice)) && Number(sellPrice) !== 0;
  const hasMargin = margin !== null && margin !== undefined && margin !== "" && Number.isFinite(Number(margin));
  const marginPct = hasSell && hasMargin ? (Number(margin) / Number(sellPrice)) * 100 : null;
  const isPositive = hasMargin ? Number(margin) >= 0 : false;

  return (
    <div className="inline-flex items-center rounded border overflow-hidden text-xs text-gray-400 w-full mx-2">
      {/* Försäljning */}
      <div className="px-4 py-2 flex items-center gap-2">
        <span className="uppercase tracking-wide">{t("Fs")}</span>
        <span className="font-normal text-sm">{format(sellPrice)}</span>
      </div>

      {/* Divider */}
      <div className="h-6 w-px bg-gray-200" />

      {/* Inköp */}
      <div className="px-4 py-2 flex items-center gap-2">
        <span className="uppercase tracking-wide">{t("Ik")}</span>
        <span className=" text-sm">{format(cost)}</span>
      </div>

      {/* Divider */}
      <div className="h-6 w-px bg-gray-200" />

      {/* Skillnad */}
      <div
        className={`px-4 py-2 flex items-center gap-2 font-medium ${
          !hasMargin
            ? "bg-yellow-100 text-yellow-700"
            : isPositive
            ? "bg-gradient-to-r from-green-50 to-green-100 text-green-700"
            : "bg-gradient-to-r from-red-50 to-red-100 text-red-700"
        }`}
      >
        <span className="uppercase tracking-wide opacity-70">{t("M")}</span>
        <span className="text-sm">{hasMargin ? format(margin) : t("Ofullständig")}</span>
        {marginPct !== null && (
          <span className="text-xs opacity-70">
            ({marginPct.toFixed(1)}%)
          </span>
        )}
      </div>
      <span className="text-xs opacity-70 text-center w-full">
         kr
      </span>
    </div>
  );
};

export default PriceMatricsComponent;


